/**
 * App layout: TopNav + LeftNav + main content (Outlet).
 * Mobile: LeftNav becomes a drawer opened via hamburger in TopNav.
 */

import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import TopNav from './TopNav';
import LeftNav from './LeftNav';
import './AppLayout.css';

export default function AppLayout() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setMobileNavOpen(false);
  }, [location.pathname]);

  function closeMobileNav() {
    setMobileNavOpen(false);
  }

  return (
    <div className="app-layout">
      <TopNav
        onMenuClick={() => setMobileNavOpen((o) => !o)}
        menuOpen={mobileNavOpen}
        menuAriaLabel="Open menu"
      />
      <div className={`app-layout-body ${mobileNavOpen ? 'mobile-nav-open' : ''}`}>
        <div
          className="app-layout-nav-backdrop"
          onClick={closeMobileNav}
          onKeyDown={(e) => e.key === 'Escape' && closeMobileNav()}
          role="button"
          tabIndex={-1}
          aria-hidden="true"
        />
        <div className="app-layout-nav-wrap">
          <LeftNav onNavigate={closeMobileNav} />
        </div>
        <main className="app-layout-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
